export default "__VITE_PUBLIC_ASSET__24b27e7a__"